var _defs, _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumidifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M347.7,458.8h-113.8v7.6c0,14.5-11.8,26.3-26.3,26.3s-26.3-11.8-26.3-26.3v-7.6h-81.5v47.6c0,3.7,3,6.8,6.8,6.8h243.1c-1.2-2-1.8-4.3-1.8-6.8v-47.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.7,248.2v203.9h81.5v-.8c0-14.5,11.8-26.3,26.3-26.3s26.3,11.8,26.3,26.3v.8h113.8V93.6c0-1.7.3-3.4.9-4.9l-242.3,6.3c-3.7,0-6.6,3.1-6.6,6.8v146.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.6,486c10.8,0,19.5-8.8,19.5-19.5v-15.3c0-10.8-8.8-19.5-19.5-19.5s-19.5,8.8-19.5,19.5v15.3c0,10.8,8.8,19.5,19.5,19.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M356.2,458.8h-1.7v47.6c0,3.7,3,6.8,6.8,6.8h117.2c3.7,0,6.8-3,6.8-6.8v-47.6h-129.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M478.5,86.8h-117.2c-3.7,0-6.8,3-6.8,6.8v358.5h130.8V93.6c0-3.7-3-6.8-6.8-6.8ZM449.6,390.9c0,7.5-6.1,13.6-13.6,13.6h-30.6c-7.5,0-13.6-6.1-13.6-13.6v-241.2c0-7.5,6.1-13.6,13.6-13.6h30.6c7.5,0,13.6,6.1,13.6,13.6v241.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M478.5,80h-117.2c-2.4,0-4.7.6-6.6,1.7l-248.5,6.4c-7.4.2-13.2,6.2-13.2,13.6v404.7c0,7.5,6.1,13.6,13.6,13.6h372c7.5,0,13.6-6.1,13.6-13.6V93.6c0-7.5-6.1-13.6-13.6-13.6ZM478.5,513.2h-117.2c-3.7,0-6.8-3-6.8-6.8v-47.6h130.8v47.6c0,3.7-3,6.8-6.8,6.8ZM106.5,513.2c-3.7,0-6.8-3-6.8-6.8v-47.6h81.5v7.6c0,14.5,11.8,26.3,26.3,26.3s26.3-11.8,26.3-26.3v-7.6h113.8v47.6c0,2.5.7,4.8,1.8,6.8H106.5ZM106.3,94.9l242.3-6.3c-.6,1.5-.9,3.2-.9,4.9v358.5h-113.8v-.8c0-14.5-11.8-26.3-26.3-26.3s-26.3,11.8-26.3,26.3v.8h-81.5V101.7c0-3.7,2.9-6.7,6.6-6.8ZM188,451.2c0-10.8,8.8-19.5,19.5-19.5s19.5,8.8,19.5,19.5v15.3c0,10.8-8.8,19.5-19.5,19.5s-19.5-8.8-19.5-19.5v-15.3ZM485.3,248.2v203.9h-130.8V93.6c0-3.7,3-6.8,6.8-6.8h117.2c3.7,0,6.8,3,6.8,6.8v154.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 398.7,
    y: 142.9,
    width: 44.2,
    height: 254.8,
    rx: 6.8,
    ry: 6.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M449.6,149.7c0-7.5-6.1-13.6-13.6-13.6h-30.6c-7.5,0-13.6,6.1-13.6,13.6v241.2c0,7.5,6.1,13.6,13.6,13.6h30.6c7.5,0,13.6-6.1,13.6-13.6v-241.2ZM436.1,397.7h-30.6c-3.7,0-6.8-3-6.8-6.8v-241.2c0-3.7,3-6.8,6.8-6.8h30.6c3.7,0,6.8,3,6.8,6.8v241.2c0,3.7-3,6.8-6.8,6.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidifier);
export default __webpack_public_path__ + "static/media/humidifier.89137a8a0be974ac09be598fe28889d0.svg";
export { ForwardRef as ReactComponent };